export var TradevestPriceRange;
(function (TradevestPriceRange) {
    TradevestPriceRange["ONE_DAY"] = "1T";
    TradevestPriceRange["ONE_MONTH"] = "1M";
    TradevestPriceRange["THREE_MONTHS"] = "3M";
    TradevestPriceRange["ONE_YEAR"] = "1J";
    TradevestPriceRange["MAX"] = "MAX";
})(TradevestPriceRange || (TradevestPriceRange = {}));
export const PriceRange = TradevestPriceRange;
//# sourceMappingURL=market-data.types.js.map